import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精选分区快速入口
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            两大核心分区，精准定位您感兴趣的内容领域
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/70 p-8 transition-all duration-300 hover:scale-[1.02]"
            >
              <div
                className={`absolute top-0 right-0 w-32 h-32 rounded-bl-full opacity-10 transition-all duration-300 group-hover:scale-150 ${
                  cat.color === 'primary' ? 'bg-primary-500' : 'bg-accent-500'
                }`}
              ></div>

              <div className="relative z-10">
                <div
                  className={`w-14 h-14 flex items-center justify-center rounded-xl mb-5 transition-all duration-300 group-hover:scale-110 ${
                    cat.color === 'primary'
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-accent-100 text-accent-600'
                  }`}
                >
                  <i className={`${cat.icon} text-2xl`}></i>
                </div>

                <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3">
                  {cat.name}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-5">
                  {cat.description}
                </p>

                <span
                  className={`inline-flex items-center gap-1 text-sm font-medium whitespace-nowrap ${
                    cat.color === 'primary' ? 'text-primary-600' : 'text-accent-600'
                  }`}
                >
                  立即探索
                  <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}